import { graphql } from 'react-relay';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

import type { useIsSiteAdminUseIsSiteAdminQuery as useIsSiteAdminUseIsSiteAdminQuery$data } from './__types__/useIsSiteAdminUseIsSiteAdminQuery.ts';
import { getIsSiteAdminFromQuery } from './getIsSiteAdminFromQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useIsSiteAdmin = () => {
	const {
		data,
		error,
		loading: isAdminCheckLoading,
	} = useQueryInterop<useIsSiteAdminUseIsSiteAdminQuery$data>(graphql`
		query useIsSiteAdminUseIsSiteAdminQuery {
			isSiteAdmin
		}
	`);

	if (error) {
		if (!isUnauthorizedError(error)) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.ADMIN_EXPERIENCE,
			});
		}
		markErrorAsHandled(error);
	}

	const isSiteAdmin = getIsSiteAdminFromQuery(data);

	return { isSiteAdmin, isAdminCheckLoading };
};
